import { Modal, ModalStateProps, TextInput } from '@mi-front/ui';
import { Button } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';

interface Props extends ModalStateProps {
  reportName: string;
  setReportName: (value: string) => void;
  onCreate: () => Promise<any>;
}

export function GipReportCreateModal(p: Props) {
  const { $t } = useIntl();

  return (
    <Modal
      size="md"
      show={p.show}
      onHide={p.onHide}
      title={
        <div style={{ display: 'flex' }}>
          <FormattedMessage
            id="audit.gipReport.createModal.title"
            defaultMessage="Crear reporte GIP"
          />
        </div>
      }
      footer={
        <div>
          <Button
            variant="contained"
            color="primary"
            onClick={p.onCreate}
            sx={{ marginRight: 1.5, minWidth: '8rem' }}
            data-cy="modal-confirm"
          >
            <FormattedMessage id="common.form.saveBtnText" defaultMessage="Guardar" />
          </Button>
        </div>
      }
    >
      <div className="">
        <div className="">
          <TextInput
            name="report_name"
            label={$t({
              id: 'audit.gipReport.createModal.nameLabel',
              defaultMessage: 'Nombre',
            })}
            placeholder={$t({
              id: 'audit.gipReport.createModal.namePlaceholder',
              defaultMessage: 'Ingresar nombre del reporte',
            })}
            value={p.reportName}
            onChange={(event) => {
              p.setReportName(event.target.value);
            }}
          />
        </div>
      </div>
    </Modal>
  );
}
